import _sfc_main from './src/collapse-transition.vue2.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElCollapseTransition = withInstall(_sfc_main);

export { ElCollapseTransition, ElCollapseTransition as default };
//# sourceMappingURL=index.mjs.map
